import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "goenga-beef-specify-image",
  templateUrl: "./beef-specify-image.component.html",
  styleUrls: ["./beef-specify-image.component.scss"],
})
export class BeefSpecifyImageComponent implements OnInit {
  @Input() part: string;

  constructor() {}

  ngOnInit(): void {}
}
